import { render, staticRenderFns } from "./VirtualAlarm.vue?vue&type=template&id=578f8ae2"
import script from "./VirtualAlarm.vue?vue&type=script&lang=js"
export * from "./VirtualAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports